import { render, staticRenderFns } from "./report-summary.vue?vue&type=template&id=16567b2b&scoped=true&"
import script from "./report-summary.vue?vue&type=script&lang=js&"
export * from "./report-summary.vue?vue&type=script&lang=js&"
import style0 from "./report-summary.vue?vue&type=style&index=0&id=16567b2b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16567b2b",
  null
  
)

export default component.exports